import React from 'react';
import {useAppDispatch} from "../../../app/hooks";
import {Box, Button, Paper, TextField, Typography} from "@mui/material";
import {closeButton, closeButtonInner, form, formInner, overlay} from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import {Controller, useForm} from "react-hook-form";
import {getResetCode} from "../authSlice";

interface IForgotPasswordFormProps {
    closeForm: () => void,
    resetPassword: () => void
}

const ForgotPasswordForm: React.FC<IForgotPasswordFormProps> = ({closeForm, resetPassword}) => {
    const dispatch = useAppDispatch();
    const {handleSubmit, control} = useForm<{ email: string }>({
        defaultValues: {
            email: ""
        }
    });


    const onSubmit = (data: { email: string }) => {
        dispatch(getResetCode({
            email: data.email
        }));

        closeForm();
        resetPassword();
    };

    return (
        <Box sx={overlay}>
            <Box>
                <Paper sx={formInner}>
                    <Box sx={closeButtonInner}>
                        <Button
                            sx={closeButton}
                            onClick={closeForm}
                        >
                            <CloseIcon sx={{width: 20}}/>
                        </Button>
                    </Box>
                    <Typography variant="h6" align="center">
                        Enter the email for getting a code to reset your password
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Box sx={form}>
                            <Controller
                                control={control}
                                defaultValue={""}
                                name={"email"}
                                rules={{
                                    required: true,
                                    minLength: 2,
                                    maxLength: 150,
                                    pattern: {
                                        value: /[^\s]/,
                                        message: "Field can not contain only spaces"
                                    }
                                }}
                                render={({
                                             field: {onChange, value},
                                             formState: {errors},
                                         }) => (
                                    <TextField
                                        sx={{pb: "30px"}}
                                        label="Email"
                                        value={value}
                                        onChange={(e) => {
                                            onChange(e)
                                        }}
                                        error={Boolean(errors.email)}
                                        helperText={
                                            errors.email && errors.email.type === "required"
                                            && <span>Email is required</span>
                                            ||
                                            errors.email && errors.email.type === "maxLength"
                                            && <span>This field can not contain more than 150 symbols</span>
                                            ||
                                            errors.email && errors.email.type === "minLength"
                                            && <span>This field can not contain less than 2 symbols</span>
                                            ||
                                            errors.email && errors.email.type === "pattern"
                                            && <span>Field can not contain only spaces</span>
                                        }
                                    />
                                )}
                            />
                            <Button variant="contained" type="submit">
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default ForgotPasswordForm;
